import { render, staticRenderFns } from "./ThirdPartyModal.vue?vue&type=template&id=b6bf086c"
import script from "./ThirdPartyModal.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyModal.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyModal.vue?vue&type=style&index=0&id=b6bf086c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports